import apiClient from "./apiClient";

export const addServiceData = async (serviceData) => {
    console.log("Payload sent to API:", serviceData); // Log the payload
    try {
        const response = await apiClient.post('ServicesRequest/Create', serviceData, {
            headers: {
                // 'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Adding service data failed:', error.response?.data || error.message);
        if (error.response?.data?.errors) {
            const validationErrors = error.response.data.errors;
            const formattedErrors = Object.keys(validationErrors).map(field => {
                return `${field}: ${validationErrors[field].join(', ')}`;
            }).join('; ');
            throw new Error(`Validation errors: ${formattedErrors}`);
        } else {
            throw new Error('Network error or unexpected issue while adding service data');
        }
    }
};

